import React from 'react';
export const skillsData = [{
  title: 'Technical Skills',
  skills: ['Product Strategy', 'Generative AI & Prompt Engineering', 'Prototyping & Wireframe - Figma', 'Product Roadmap', 'User & Market Research', 'LLMs']
}, {
  title: 'Soft Skills',
  skills: ['Strategic & Data-Driven Decision Making', 'Effective Communication', 'Cross-functional Collaboration', 'Stakeholder Management', 'Leadership', 'Problem Solving']
}, {
  title: 'Domain Expertise',
  skills: ['Telecom', 'FMCG', 'Consulting', 'Ecommerce', 'Subscription Models', 'Digital Transformation']
}];
export const careerHighlights = [{
  title: 'Subscription Feature Optimization',
  description: 'Led the development of a new feature in the subscription domain that reduced user friction by 10%.',
  icon: 'TrendingUpIcon'
}, {
  title: 'SEA Market Expansion',
  description: 'Spearheaded the improvement of an existing feature that increased user onboarding across SEA markets, adding 50K+ new subscribers.',
  icon: 'UsersIcon'
}, {
  title: 'Customer Insights Platform',
  description: 'Led the design and launch of a global customer insights platform for an FMCG enterprise, improving decision-making accuracy by 65%.',
  icon: 'LineChartIcon'
}, {
  title: 'Automated Reporting Solution',
  description: "Delivered an automated reporting solution that reduced field engineers' waiting time by 70% during 4G/5G installation tasks for AT&T.",
  icon: 'ClockIcon'
}];